<template>
  <div class="news-cont-box" ref="box">
    <ul class="app-view" v-if="versionUrl">
      <li>
        <img :src="anyangIcon"/>
        <!-- <p>{{ appName }}</p> -->
      </li>
      <van-button
        size="mini"
        class="down-app-btn"
        @click="downApp"
        v-if="versionUrl">打开APP
      </van-button>
    </ul>
    <div class="view-box audio-view-box" v-if="versionUrl"></div>
    <div class="special-cont-box">
      <div class="special-cover">
        <img  :src="newSubject.imagePath" alt="">
      </div>
      <div class="special-cont">
        <div class="special-titel">
          {{newSubject.title}}
        </div>
        <div class="special-info">
          <p v-if="showAll" class="limit-info">{{newSubject.introduce}}</p>
          <p v-else class="all-info">{{newSubject.introduce}}</p>
          <div class="limit-button" v-if="showAll&&showBack" @click="showAll=false">展开<i class="el-icon-caret-bottom limit-icon"></i></div>
          <div class="limit-button" v-if="!showAll&&showBack" @click="showAll=true">收起<i class="el-icon-caret-top limit-icon"></i></div>
        </div>
      </div>
      <div class="line-check"></div>
      <div class="relevant-special">
        <div class="relevant-title">
          相关报道
        </div>
        <div v-if="relevantList.length!==0" class="relevant-list">
          <div class="relevant-item" v-for="(item,index) in relevantList" :key="index" @click="downApp">
            <div class="relevant-item-left">
              <div class="item-left-title">
                {{item.title}}
              </div>
              <div class="item-left-info">
                <span v-if="item.source" style="margin-right:10px">{{item.source}}</span>
                <span v-if="item.createTime" >{{format(new Date(item.createTime),'MM-dd')}}</span>
                <span style="float: right;">{{item.releaseNum}}学习</span>
              </div>
            </div>
            <div class="relevant-item-right">
              <img v-if="item.coverimgPathList.length>0" :src="item.coverimgPathList[0]" alt=""/>
              <img v-else :src="require('@/assets/img/banfre.png')" alt=""/>
            </div>
          </div>
        </div>
        <div v-else class="none-relevant-list">
          暂无相关内容
        </div>
        <van-button
            size="large"
            type="info"
            class="open-app"
            @click="downApp"
            v-if="versionUrl">打开安阳融媒APP，查看更多评论
        </van-button>
      </div>
    </div>
    
  </div>
</template>

<script>
import * as sctipts from "../../service/share";
import share from "../../utils/share";
import { format } from "date-fns";
export default {
  data () {
    return {
      showAll:true, // true展开/false收起
      showBack:false, // 
      pageType:'',
      versionUrl: "",
      appName: "",
      appIcon: '',
      anyangIcon: require('../../assets/img/logo.png'),
      params:{
        columnId: '',
        keyWord: '',
        createTime: '', // 时间 1过去7天 2过去30天 3过去90天 自定义时间20190909,20190920
        pageIndex: '1',
        pageSize: '10',
      },
      relevantList:[],
      newSubject:{},
    };
  },
  mounted () {
    //箭头页面加载返回页面高度
    // let observer = new MutationObserver((mutations, observer) => {
    //   this.initPage();
    //   let images = this.$refs.Introduction.querySelectorAll("img");
    //   const promises = Array.prototype.slice.call(images).map((node) => {
    //     return new Promise((resolve, reject) => {
    //       let loadImg = new Image();
    //       loadImg.src = node.src;
    //       loadImg.onload = () => {
    //         resolve(node);
    //       };
    //     });
    //   });
    //   // 利用Promise.all监听所有图片加载完成
    //   Promise.all([promises])
    //     .then((results) => {
    //       //执行方法
    //       this.initPage();
    //     })
    //     .catch((e) => {
    //       console.error("网络异常或其他程序异常", e);
    //     });
    // });
    // //创建实例
    // observer.observe(this.$refs.Introduction, {
    //   childList: true, // 子节点的变动（新增、删除或者更改）
    //   attributes: true, // 属性的变动
    //   characterData: true, // 节点内容或节点文本的变动
    //   subtree: true, // 是否将观察器应用于该节点的所有后代节点
    //   attributeFilter: ["class", "style", "height"], // 观察特定属性
    //   attributeOldValue: true, // 观察 attributes 变动时，是否需要记录变动前的属性值
    //   characterDataOldValue: true, // 观察 characterData 变动，是否需要记录变动前的值
    // });
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    if (this.$route.query.id) {
      sctipts
        .specialSubject(this.$route.query.id)
        .then(({data}) => {
          if (data.status == 0) {
            if (data.data) {
              this.newSubject = data.data
              this.getDowlist(data.data.columnId)
              if (data.data.introduce.length>=62) {
                this.showBack=true
              }else{
                this.showBack=false
              }
              let obj={
                title: data.data.title,
                desc: data.data.introduce,
                link: location.href,
                img: data.data.imagePath,
              }
              let url = process.env.NODE_ENV === 'production' ? window.location.href : process.env.VUE_APP_URL+this.$route.fullPath;
              share.getJSSDK(url.split('#')[0],obj)

              //关闭遮罩
              // if (this.equipmentType() == "Android") {
              //   try {
              //     window.Android.didFinishLayer();
              //   } catch (error) { }
              // } else if (this.equipmentType() == "iOS") {
              //   try {
              //     window.webkit.messageHandlers.didFinishLayer.postMessage(
              //       "didFinishLayer"
              //     );
              //   } catch (error) { }
              // }
            }
          }
        })
        .catch((res) => {
          console.log("连接服务器错误");
        });
      sctipts
        .getAppUrl({
          type: this.type,
          bundleID: this.$route.query.bundleID
        })
        .then(({
          data
        }) => {
          if (data.status == 0) {
            if (data.data) {
              this.versionUrl = data.data.versionUrl;
              this.appName = data.data.applicationName;
              this.appIcon = data.data.applicationHeadPath;
              this.appScheme = data.data.applicationUrlScheme
            }
          } else {
            console.log(data.desc);
          }
        });
    } else {
      console.log("未获取id");
    }
  },
  computed: {
  },
  methods: {
    format,
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    initTime (time, type) {
      return sctipts.initTime(time, type);
    },
    getDateDiff (time) {
      return sctipts.getDateDiff(time);
    },
    downApp (item) {
      // 1文章,2 视频, 3 电视直播, 4 直播详情, 5 栏目详情, 6 图片详情, 7 爆料详情, 8 音频详情, 9 活动直播详情,10新闻专题,11人物专题
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(10)}?newsSpecialId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(10)}?newsSpecialId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    // initPage () {
    //   //设置视频不能全屏播放
    //   let videoDomArr = this.$refs.Introduction.querySelectorAll("video");
    //   for (let i = 0; i < videoDomArr.length; i++) {
    //     videoDomArr[i].setAttribute("x5-video-player-type", "h5")
    //     videoDomArr[i].setAttribute("webkit-playsinline", "")
    //     videoDomArr[i].setAttribute("playsinline", "")
    //     videoDomArr[i].setAttribute("controlslist", "nodownload")
    //   }
    //   if (this.equipmentType() == "Android") {
    //     try {
    //       window.Android.resize(this.$refs.box.offsetHeight);
    //     } catch (error) { }
    //   }
    // },
    // 相关专题
    getDowlist (id) {
      this.params.columnId=id
      sctipts.notokenList(this.params).then(res=>{
        if (res.data.status == 0){
          console.log(res.data.data);
          this.relevantList=res.data.data.list
        }
      })
    },
  },
};
</script>

<style scoped>

.news-cont-box {
  /* padding: 0 16PX; */
  /* box-sizing: border-box; */
  overflow: hidden;
}
.special-cont-box{
  margin-top: 12px;
}
.special-cover{
  height: 280px;
  padding-top: 12px;
}
.special-cover img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.special-cont{
  padding: 20px 16px;
}
.special-titel{
  font-size: 18px;
  font-family: SourceHan;
  font-weight: bold;
  color: #333333;
  line-height: 21px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.special-info p{
  margin-top: 12px;
  font-size: 16px;
  font-family: SourceHan;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  text-align: justify;
}
.special-info .limit-info{
  height: 66px;
  text-align: justify;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.special-info .limit-button{
  font-size: 12px;
  font-family: SourceHan;
  font-weight: 500;
  color: #D9001B;
  line-height: 18px;
  text-align: right;
}
.limit-icon{
  margin-left: 5px;
  font-size: 14px;
}
.line-check{
  width: 100%;
  height: 8px;
  background-color: rgba(245, 245, 245, 1);
}
/* 相关专题 */
.relevant-special{
  padding: 0 16px;
}
.relevant-title{
  font-size: 18px;
  font-family: SourceHan;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
  margin: 20px 0;
}

.item-left-title{
  width: 205px;
  font-size: 16px;
  font-family: SourceHan;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  height: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.relevant-item{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
  padding: 20px 0px;
}
.relevant-item:first-of-type{
  padding-top: 0px;
}
.relevant-item:last-of-type{
  border: none;
}
.relevant-item-right{
  width: 125px;
  height: 90px;
  background-color: #e2dfdf;
  border-radius: 5px;
}
.relevant-item-right img{
  display: block;
  width: 100%;
  height: 100%;
  margin: auto;
  object-fit: cover;
  border-radius: 5px;
}
.item-left-info{
  font-size: 12px;
  font-family: SourceHan;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
  margin-top: 35px;
}
.relevant-list{
  padding-top: 15px;
  margin-bottom: 40px;
}
.none-relevant-list{
  width: 100%;
  height: 240px;
  text-align: center;
  font-size: 16px;
  font-family: SourceHan;
  font-weight: 900;
  color: #666666;
  line-height: 240px;
}
.open-app {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  background-color: #be1928;
  color: #fff;
  font-size: 14px;
  border-radius: 30px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}
.open-app-border {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  border: 1px solid #fa3e3d;
  color: #fa3e3d !important;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}
</style>
